export const CONTACTS = {
	TABLE_HEADERS: [
		{
			name: 'Name',
			value: 'lastName',
			className: 'name',
		},
		{
			name: 'Email',
			value: 'email',
			className: 'email',
		},
		{
			name: 'Status',
			value: 'status',
			className: 'status',
		},
		{
			name: 'Last Communication',
			value: 'last',
			className: 'last',
		},
	],
	FILTER_OPTIONS: [
		{
			type: 'Lead Status',
			data: [
				{
					desc: 'New',
					id: 1,
				},
			],
		},
	],
};

export const TYPES = {
	STATUS: 'Lead Status',
};
